import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'

const BalancesForm: React.FC<BalancesFormProps> = ({
  defaultValues,
  onSubmitBalance,
  onCancel,
}) => {
  const options = [
    {
      text: 'Ingreso',
      value: 'INCOME',
    },
    {
      text: 'Egreso',
      value: 'EXPENSES',
    },
  ]
  const form = useForm({
    defaultValues: {
      ...defaultValues,
      type: options[0].value,
    },
  })

  return (
    <div>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-2`}
        onSubmit={(v) => onSubmitBalance(v)}
      >
        <h2 className="col-span-12 mt-1 text-primary-900 font-bold dark:text-white">
          Balances
        </h2>

        <FormItem name="amount" classes="lg:col-span-4 col-span-6">
          <InputText label="Cantidad" maxLength={10} />
        </FormItem>

        <FormItem
          name="transactionType"
          defaultValue={options[0]}
          classes="lg:col-span-3 col-span-6"
        >
          <Select
            options={options}
            setSelectedHelper={() => null}
            label="Tipo"
          />
        </FormItem>

        <FormItem name="description" classes="lg:col-span-5 col-span-12">
          <InputText label="Descripcion" maxLength={200} />
        </FormItem>

        <div className="col-span-12 h-full flex flex-row mt-5">
          <div className="w-1/2 mr-5 pl-1">
            <Button type="outline" classes="w-full" onClick={() => onCancel()}>
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit">
              {'Actualizar'}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  )
}

interface BalancesFormProps {
  defaultValues: any
  onSubmitBalance: Function
  onCancel: Function
}

export default BalancesForm
